var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.valueData,
        expression: "valueData"
      }
    ],
    staticClass: "BudoTextarea",
    attrs: { placeholder: "在这里输入标题", rows: "1" },
    domProps: { value: _vm.valueData },
    on: {
      input: [
        function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.valueData = $event.target.value
        },
        _vm.onInput
      ]
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a34f4b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a34f4b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BudoTextarea.vue
// module id = 577
// module chunks = 75